export function coverUrl(issue) {
    const image = issue.img || `/tapas/Bds${issue.numero}-small.png`;
    return image.startsWith('/') ? `${process.env.PUBLIC_URL}${image}` : image;
}
